export default __webpack_public_path__ + "static/media/welcome-bg2.244fd590.png";